import 'bootstrap/dist/css/bootstrap.min.css';
import { Banner } from './Banner';
import { Projects } from './Projects';

function HomePage() {
  return (
    <div className="App">
      <Banner />
      {/* <Skills /> */}
      <Projects />
      {/* <Contact /> */}
      {/* <Footer /> */}
    </div>
  );
}

export default HomePage;
